<!--我的收藏-->
<template>
  <div class="mine-collection-container">
    <headerIndex/>
    <!--面包削-切换导航栏-->
    <div class="collection-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/outsourceDemand/index' }">交易大厅</el-breadcrumb-item>
        <el-breadcrumb-item>我的收藏</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!--正文内容-->
    <div class="mine-collection-content">
      <el-row :gutter="16">
        <el-col :span="24">
          <div class="left-collection">
            <div class="left-top-search">
              <span>我的收藏</span>
              <el-button type="danger" @click="editCollection" plain>{{ edit ? '完成' : '编辑' }}</el-button>
            </div>
            <div class="collection-list" v-if="biddingInfo.length>0" :style="'min-height:'+min_height+'px;'">
              <el-row :gutter="16">
                <el-col :span="12" v-for="(bid,idnex) of biddingInfo" class="el-bid-list" style="padding: 0px 15px;">
                  <div class="grid-content bg-purple" @click="!edit ? biddingDetails(bid) : ''">
                    <div class="col-checkbox" v-if="edit">
                      <el-checkbox-group v-model="checkedCities" @change="handleCheckedChange">
                        <el-checkbox :value="bid.id" :label="bid.id"/>
                      </el-checkbox-group>
                    </div>
                    <div class="grid-list">
                      <div class="bid-status">
                        <div class="bid-left-status">
                          <i class="tag-1">
                            <span class="tag-red">招投标</span>
                            <span class="tag-white">{{ bid.money }}{{ bid.moneyUnit }}</span>
                          </i>
                          <i class="tag-2" v-if="bid.urgent==1">急</i>
                          <i class="tag-2" v-if="bid.top==1">置顶</i>
                        </div>
                        <div class="bid-right-status">
                          <!--状态（-1:未参与，0：参与中，1：投标成功，2：选标失败）-->
                          <i class="status-1" v-if="bid.status==0"/>
                          <i class="status-2" v-if="bid.status==1"/>
                          <i class="status-3" v-if="bid.status==2"/>
                        </div>
                      </div>
                      <p class="small-title SourceHanSansCN">{{ bid.title }}</p>
                      <p class="bottom-p">
                        <span class="left-span"><i class="iconfont icon-clock"/>{{ bid.statusFormat }}</span>
                        <span class="right-span"><i class="iconfont icon-user"/>{{ bid.nums }}人报名</span>
                      </p>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="collection-list" v-else :style="'min-height:'+min_height+'px;'">
              <el-empty description="没有收藏数据"/>
            </div>
          </div>
          <!-- 分页 -->
          <page :total="tablePage.total" class="pagination" @currentPage="currentPage"
                :page="tablePage.currentPage" :limit="tablePage.pageSize" style="padding: 10px 20px 10px 10px;"/>
          <div class="footer-fixed" v-if="edit">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange"
                         style="margin-right: 30px;">全选
            </el-checkbox>
            <el-button type="danger" @click="dialogVisible=true" :disabled="checkedCities.length>0 ? false : true">删除
            </el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <Hang/>
    <home_footer/>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="450px" class="mine-collection-dialog" center>
      <span>确定取消收藏？</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="deleteCollection">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import headerIndex from "@/components/header/headerIndex";
import home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hang";
import page from "@/components/page/pages";
import {favoritesList, delFavorites} from '@/api/cloudServiceApi'

export default {
  name: "mineCollection",
  components: {headerIndex, Hang, home_footer, page},
  data() {
    return {
      cid: 0,
      /*分页*/
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      sortType: '全部',
      tenderStatus: -1,
      personalInfo: {},
      biddingInfo: [],
      checkedCities: [],
      isIndeterminate: false,
      checkAll: false,
      min_height: document.documentElement.clientHeight - 410,
      edit: false,
      dialogVisible: false,
    }
  },
  methods: {
    /*获取我的招标信息*/
    getMineBidInfo() {
      favoritesList({
        page: this.tablePage.currentPage,
        pageLimit: this.tablePage.pageSize,
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0
      }).then(res => {
        if (res.code == 200) {
          this.biddingInfo = res.content.rows;
          this.tablePage.total = res.content.total;
        }
      })
    },
    /*发布需求*/
    releaseDemand() {
      /**
       * @param verified_type 认证类型（1：个人，2：政府，3：企业，4：媒体，5：其他）
       * @param state 认证状态（1：已认证。0未认证,2:审核中，-1：认证失败）
       */
      if (this.cid!=0){
        if (this.personalInfo.verified_type == 3 && this.personalInfo.state == 1) {
          this.$router.push({path: '/outsourceDemand/releaseDemand',})
        } else {
          this.dialogVisible2 = true;
        }
      }else{
        that.$alert('您还没有登录,是否进行登录', {
          confirmButtonText: '确定',
          callback: action => {
            that.$router.replace({
              path: '/login'
            })
          }
        })
      }
    },
    /*切换招标状态调用查询接口*/
    checkScreen(row) {
      if (this.tenderStatus != row.value) {
        this.sortType = row.name;
        this.tenderStatus = row.value;
        this.tablePage.currentPage = 1;
        this.getMineBidInfo();
      }
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getMineBidInfo();
    },
    /*编辑我的收藏*/
    editCollection() {
      this.edit = this.edit ? false : true;
    },
    /*监听多选框勾选*/
    handleCheckedChange(val) {
      if (this.biddingInfo.length == this.checkedCities.length) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
    /*全选*/
    handleCheckAllChange(val) {
      if (val == false) {
        this.checkedCities = [];
      } else {
        for (let list of this.biddingInfo) {
          this.checkedCities.push(list.id);
        }
      }
    },
    /*取消收藏*/
    deleteCollection() {
      delFavorites({
        delAll: 0,
        ids: this.checkedCities,
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0
      }).then(res => {
        if (res.code == 200) {
          this.$message.success('操作成功！');
          this.dialogVisible = false;
          this.checkedCities = [];
          this.getMineBidInfo();
        } else {
          this.$message.error('操作失败！');
        }
      })
    },
    /*招标详情*/
    biddingDetails(demand) {
      this.$router.push({
        path: '/outsourceDemand/biddingDetails',
        query: {
          id:demand.zid,
          from:3,
        }
      })
    },
  },
  mounted() {
    this.getMineBidInfo();
  },
  beforeMount() {
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    this.personalInfo = sessionStorage.getItem('personalInfo') != null && sessionStorage.getItem('personalInfo') != undefined && sessionStorage.getItem('personalInfo') != '' ? JSON.parse(sessionStorage.getItem('personalInfo')) : '';
  }
}
</script>
<style scoped>
.mine-collection-container >>> .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-weight: bold;
  color: #5D5D5D;
}

.mine-collection-container >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.mine-collection-container >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.mine-collection-container >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.mine-collection-container >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 100;
  color: #5D5D5D;
  font-family: 'SourceHanSansCN';
}

.mine-collection-container >>> .mine-collection-content .left-collection .left-top-search .el-button--danger.is-plain {
  color: #FE273B;
  background: #FFF2F3;
  border-color: #FE273B;
  padding: 7px 15px;
}

/*列表多选框样式*/
.mine-collection-container >>> .mine-collection-content .left-collection .collection-list .bg-purple .el-checkbox__inner {
  border-radius: 50%;
  width: 20px;
  height: 20px;
  border: 1px solid #666666;
  background: #ffffff;
}

.mine-collection-container >>> .mine-collection-content .left-collection .collection-list .bg-purple .el-checkbox__input.is-checked .el-checkbox__inner,
.mine-collection-container >>> .mine-collection-content .left-collection .collection-list .bg-purple .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #FE273B;
  border-color: #FE273B;
}

.mine-collection-container >>> .mine-collection-content .left-collection .collection-list .bg-purple .el-checkbox__inner::after {
  border-width: 2px;
  height: 10px;
  left: 6px;
  top: 2px;
  width: 4px;
}

.mine-collection-container >>> .mine-collection-content .left-collection .collection-list .bg-purple .el-checkbox.is-bordered {
  padding: 0px 15px 0px 20px;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  height: 100px;
  background: #F4F8FA;
  display: flex;
  width: 48%;
  align-items: center;
}

.mine-collection-container >>> .mine-collection-content .left-collection .collection-list .bg-purple .el-checkbox {
  color: #F3F9FF;
}

.mine-collection-container >>> .mine-collection-content .left-collection .collection-list .bg-purple .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #F3F9FF;
}

/*底部全选框样式*/
.mine-collection-container >>> .mine-collection-content .footer-fixed .el-checkbox__inner {
  border-radius: 50%;
  width: 20px;
  height: 20px;
  border: 1px solid #666666;
  background: #ffffff;
}

.mine-collection-container >>> .mine-collection-content .footer-fixed .el-checkbox__input.is-checked .el-checkbox__inner,
.mine-collection-container >>> .mine-collection-content .footer-fixed .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #FE273B;
  border-color: #FE273B;
}

.mine-collection-container >>> .mine-collection-content .footer-fixed .el-checkbox__inner::after {
  border-width: 2px;
  height: 10px;
  left: 6px;
  top: 2px;
  width: 4px;
}

.mine-collection-container >>> .mine-collection-content .footer-fixed .el-checkbox.is-bordered {
  padding: 0px 15px 0px 20px;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  height: 100px;
  background: #F4F8FA;
  display: flex;
  width: 48%;
  align-items: center;
}

.mine-collection-container >>> .mine-collection-content .footer-fixed .el-checkbox {
  color: #333333;
}

.mine-collection-container >>> .mine-collection-content .footer-fixed .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #FE273B;
}

/*底部删除功能按钮样式*/
.mine-collection-container >>> .mine-collection-content .footer-fixed .el-button--danger {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
  padding: 10px 20px;
}

.mine-collection-container >>> .mine-collection-content .footer-fixed .el-button--danger:hover {
  color: #FE273B;
  background: #fef0f0;
  border-color: #FE273B;
}

/* 设置dialog弹出框的样式 */
.mine-collection-dialog >>> .el-dialog__header {
  border-bottom: 1px solid #e5e5e5;
  padding: 15px 20px;
  background: #f5f5f5;
  border-radius: 10px 10px 0px 0px;
  vertical-align: middle;
  text-align: initial;
}

.mine-collection-dialog >>> .el-dialog--center .el-dialog__body {
  text-align: center;
  padding: 30px 25px 30px;
}

.mine-collection-dialog >>> .el-dialog--center {
  border-radius: 5px;
}

.mine-collection-dialog >>> .el-button--danger {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
  padding: 10px 20px;
}

.mine-collection-dialog >>> .el-button--danger:hover {
  color: #FE273B;
  background: #fef0f0;
  border-color: #FE273B;
}

.mine-collection-dialog >>> .el-dialog__footer {
  padding: 10px 20px 50px;
}
</style>
<style scoped lang="scss">
.mine-collection-container {
  background: #F5F5F5;

  .collection-breadcrumb {
    padding: 20px 18%;
    min-width: 76rem;
    background: #F5F5F5;
  }

  .mine-collection-content {
    margin: 0px 18% 30px;
    min-width: 76rem;
    background: #F5F5F5;
    padding-right: 18%;
    .left-collection {
      background: #ffffff;

      .left-top-search {
        border: 1px solid #EDEDED;
        padding: 15px 40px 15px 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .collection-list {
        padding: 30px 30px 20px;
        border: 1px solid #EDEDED;
        border-top: none;

        .el-bid-list {
          margin-bottom: 20px;

          .bg-purple {
            background: #F3F9FF;
            border-radius: 8px;
            padding: 30px 20px;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            .col-checkbox {
              width: 60px;
              display: flex;
              justify-content: flex-start;
            }

            .grid-list {
              width: 100%;

              .bid-status {
                display: flex;
                justify-content: space-between;

                .bid-left-status {
                  .tag-1 {
                    font-style: normal;
                    cursor: pointer;

                    .tag-red {
                      padding: 10px;
                      color: #ffffff;
                      background: #FE273B;
                      font-size: 14px;
                      border-radius: 6px 0px 0px 6px;
                      border: 1px solid #FE273B;
                    }

                    .tag-white {
                      padding: 10px;
                      color: #FE273B;
                      background: white;
                      font-size: 14px;
                      border: 1px solid #FE273B;
                      border-radius: 0px 6px 6px 0px;
                    }
                  }

                  .tag-2 {
                    font-style: normal;
                    color: #FE273B;
                    border-radius: 6px;
                    border: 1px solid #FE273B;
                    padding: 10px;
                    margin-left: 20px;
                    font-size: 14px;
                    cursor: pointer;
                  }
                }

                .bid-right-status {
                  height: 76px;
                  width: 94px;
                  margin-top: -45px;
                  position: absolute;
                  margin-left: 40%;
                  /* 状态（0：参与中，1：投标成功，2：选标失败）*/
                  .status-1 {
                    width: 94px;
                    height: 76px;
                    background: url("~@/assets/img/cloud/participating.png");
                    background-size: 100% 100%;
                    position: absolute;
                  }

                  .status-2 {
                    width: 94px;
                    height: 76px;
                    background: url("~@/assets/img/cloud/bid_success.png");
                    background-size: 100% 100%;
                    position: absolute;
                  }

                  .status-3 {
                    width: 94px;
                    height: 76px;
                    background: url("~@/assets/img/cloud/biddingToError.png");
                    background-size: 100% 100%;
                    position: absolute;
                  }
                }
              }

              .small-title {
                color: #333333;
                font-size: 18px;
                text-align: left;
                cursor: context-menu;
                margin-block-end: 0em;
                padding-top: 10px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                word-wrap: break-word;
                word-break: break-all;

                .user-name {
                  font-size: 16px;
                  color: #333333;
                }

                .el-position {
                  font-style: normal;
                  font-size: 12px;
                  color: #ffffff;
                  background: #FF9600;
                  padding: 3px 5px;
                  border-radius: 4px;
                  margin-left: 10px;
                }

                .right-icon {
                  float: right;
                  width: 30px;
                  height: 30px;

                  .icon-phone {
                    background: url("~@/assets/img/cloud/dianhua.png");
                    width: 30px;
                    height: 30px;
                    background-size: 100% 100%;
                    position: absolute;
                    cursor: pointer;
                  }
                }
              }

              .gray-p {
                color: #999999;
                font-size: 14px;
              }

              .bottom-p {
                margin-block-start: 0em;
                margin-block-end: 0em;
                padding-top: 10px;
                width: 100%;
                display: flex;
                justify-content: space-between;

                .left-span {
                  color: #666666;
                  font-size: 14px;
                }

                .right-span {
                  color: #666666;
                  font-size: 14px;
                  float: right;
                }

                .iconfont {
                  color: #333333;
                }
              }
            }
          }
        }
      }
    }

    .collection-demand {
      background: url("~@/assets/img/cloud/releaseDemand.png") no-repeat;
      background-size: 100% 100%;
      height: 196px;
      cursor: pointer;
    }

    .footer-fixed {
      padding: 15px 40px;
      background: #ffffff;
      margin-top: 15px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
</style>
<style>
.el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
  color: #FE273B;
  font-weight: normal;
}

.isActive {
  color: #FE273B;
}
</style>